import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addAppartmentsProgrammationsApi, addBureauxProgrammationsApi, addLcProgrammationsApi, addVillasProgrammationsApi, AppartmentBody, BureauxBody, LcBody, VillaBody } from "../../api/programmation.api";


export interface ProgrammationState {
  loading: "idle" | "pending" | "succeeded" | "failed";
  
}

const initialState: ProgrammationState = {
  loading: "idle",
  
};

export const createProgrammationAppartements: any = createAsyncThunk(
  "prgrammation/addAppartments",
  async (newProgrammations: AppartmentBody[], { dispatch }) => {
    const programmationIds = await addAppartmentsProgrammationsApi(newProgrammations, "programmation/appartements/");
    return programmationIds;
  }
);

export const createProgrammationVillas: any = createAsyncThunk(
    "prgrammation/addVillas",
    async (newProgrammations: VillaBody[], { dispatch }) => {
      const programmationIds = await addVillasProgrammationsApi(newProgrammations, "programmation/villas/");
      return programmationIds;
    }
  );

  export const createProgrammationBureaux: any = createAsyncThunk(
    "prgrammation/addBureaux",
    async (newProgrammations: BureauxBody[], { dispatch }) => {
      const programmationIds = await addBureauxProgrammationsApi(newProgrammations, "programmation/bureaux/");
      return programmationIds;
    }
  );

  export const createProgrammationLocauxCommerciaux: any = createAsyncThunk(
    "prgrammation/addLocauxCommerciaux",
    async (newProgrammations: LcBody[], { dispatch }) => {
      const programmationIds = await addLcProgrammationsApi(newProgrammations, "programmation/lc/");
      return programmationIds;
    }
  );



export const programmationsSlice = createSlice({
  name: "programmations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(createProgrammationAppartements.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createProgrammationAppartements.fulfilled, (state, action) => {
        state.loading = "succeeded";
      })
      .addCase(createProgrammationAppartements.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createProgrammationLocauxCommerciaux.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createProgrammationLocauxCommerciaux.fulfilled, (state, action) => {
        state.loading = "succeeded";
      })
      .addCase(createProgrammationLocauxCommerciaux.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createProgrammationBureaux.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createProgrammationBureaux.fulfilled, (state, action) => {
        state.loading = "succeeded";
      })
      .addCase(createProgrammationBureaux.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createProgrammationVillas.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createProgrammationVillas.fulfilled, (state, action) => {
        state.loading = "succeeded";
      })
      .addCase(createProgrammationVillas.rejected, (state) => {
        state.loading = "failed";
      })
      
  },
});

export default programmationsSlice.reducer;
